
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Profile', path: '/profile' },
    { name: 'Discography', path: '/discography' },
    { name: 'Live', path: '/live' },
    { name: 'Blog', path: '/blog' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
            久下暁雅
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              ホーム
            </Link>
            <Link to="/profile" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              プロフィール
            </Link>
            <Link to="/discography" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              ディスコグラフィー
            </Link>
            <Link to="/live" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              ライブ
            </Link>
            <Link to="/news" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              ニュース
            </Link>
            <Link to="/blog" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              ブログ
            </Link>
            <Link to="/contact" className="text-white hover:text-purple-300 transition-colors cursor-pointer">
              お問い合わせ
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                ホーム
              </Link>
              <Link 
                to="/profile" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                プロフィール
              </Link>
              <Link 
                to="/discography" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                ディスコグラフィ
              </Link>
              <Link 
                to="/blog" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                ブログ
              </Link>
              <Link 
                to="/live" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                ライブ情報
              </Link>
              <Link 
                to="/news" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                ニュース
              </Link>
              <Link 
                to="/contact" 
                className="text-gray-700 hover:text-black transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                お問い合わせ
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}